// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font-family: Arial, sans-serif;
  background-color: #f8f9fa;
}

.event-img {
  width: 100%;
  height: auto;
  border-radius: 5px;
}

.event-thumbnail {
  width: 90%;
  height: auto;
  border-radius: 5px;
}

.event-title {
  font-size: 1.2rem;
  font-weight: bold;
  margin-top: 10px;
}

.text-danger {
  color: red;
}

.tag-cart-btn {
  /* background:#396D72; */
  position: absolute;
  z-index: 10;
  top: 1px;
  left: 5px;
  /* size: 10px; */
  z-index: 10;
  /* width: 10%; */
  height: 35px;
  width: 35px;
  filter: sepia(1) saturate(1.6) hue-rotate(160deg) brightness(0.9);


  /* outline: none;
  border: none;
  padding: 5px 10px;
  transition: all 0.5s ease; */

}

.tag-cart-btn:hover {
  /* background:#5ba4aa; */
}

.tag-search-btn {
  background: white;
  /* border: 1px solid #396D72; */
  border-radius: 100%;

  /* display: none; */
}

.tag-search-btn svg {

  color: #396D72;
  width: 20px;
  height: 20px;
  opacity: 0.5;
}

.tag-search-btn:hover svg {
  /* color:white;     */
  /* size: 22px; */
  height: 22px;
  width: 22px;
}

.tag-search-btn:hover {
  /* background:#396D72; */
  background: white;
}


/* @media (min-width: 992px) {
  .lg-grid-autofit {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px; 
  }
} */

.imgs-grid {
  display: grid;
  row-gap: 10px;
  justify-content: space-evenly;
  align-content: center;
  grid-template-columns: repeat(auto-fill, minmax(270px, 300px));
}

.imgs-grid-item {

}

/* @media all and (max-width: 800px) {
  .imgs-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 230px));
 
  }
} */

@media all and (max-width: 800px) {
  .imgs-grid {
    grid-template-columns: repeat(auto-fill, minmax(200px, 230px));
 
  }
}

@media all and (min-width: 800px) {
  .imgs-grid {
    gap: 13px;
    
  }
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,iEAAiE;;;EAGjE;;;8BAG4B;;AAE9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,mBAAmB;;EAEnB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;AACnB;;;AAGA;;;;;;GAMG;;AAEH;EACE,aAAa;EACb,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,8DAA8D;AAChE;;AAEA;;AAEA;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,8DAA8D;;EAEhE;AACF;;AAEA;EACE;IACE,SAAS;;EAEX;AACF","sourcesContent":["body {\n  font-family: Arial, sans-serif;\n  background-color: #f8f9fa;\n}\n\n.event-img {\n  width: 100%;\n  height: auto;\n  border-radius: 5px;\n}\n\n.event-thumbnail {\n  width: 90%;\n  height: auto;\n  border-radius: 5px;\n}\n\n.event-title {\n  font-size: 1.2rem;\n  font-weight: bold;\n  margin-top: 10px;\n}\n\n.text-danger {\n  color: red;\n}\n\n.tag-cart-btn {\n  /* background:#396D72; */\n  position: absolute;\n  z-index: 10;\n  top: 1px;\n  left: 5px;\n  /* size: 10px; */\n  z-index: 10;\n  /* width: 10%; */\n  height: 35px;\n  width: 35px;\n  filter: sepia(1) saturate(1.6) hue-rotate(160deg) brightness(0.9);\n\n\n  /* outline: none;\n  border: none;\n  padding: 5px 10px;\n  transition: all 0.5s ease; */\n\n}\n\n.tag-cart-btn:hover {\n  /* background:#5ba4aa; */\n}\n\n.tag-search-btn {\n  background: white;\n  /* border: 1px solid #396D72; */\n  border-radius: 100%;\n\n  /* display: none; */\n}\n\n.tag-search-btn svg {\n\n  color: #396D72;\n  width: 20px;\n  height: 20px;\n  opacity: 0.5;\n}\n\n.tag-search-btn:hover svg {\n  /* color:white;     */\n  /* size: 22px; */\n  height: 22px;\n  width: 22px;\n}\n\n.tag-search-btn:hover {\n  /* background:#396D72; */\n  background: white;\n}\n\n\n/* @media (min-width: 992px) {\n  .lg-grid-autofit {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px; \n  }\n} */\n\n.imgs-grid {\n  display: grid;\n  row-gap: 10px;\n  justify-content: space-evenly;\n  align-content: center;\n  grid-template-columns: repeat(auto-fill, minmax(270px, 300px));\n}\n\n.imgs-grid-item {\n\n}\n\n/* @media all and (max-width: 800px) {\n  .imgs-grid {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 230px));\n \n  }\n} */\n\n@media all and (max-width: 800px) {\n  .imgs-grid {\n    grid-template-columns: repeat(auto-fill, minmax(200px, 230px));\n \n  }\n}\n\n@media all and (min-width: 800px) {\n  .imgs-grid {\n    gap: 13px;\n    \n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
